import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { OnboardingStep, SharedData } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditOnboardingStep from './EditOnboardingStep.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { Table } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStepsTableActions',
  props: {
    onboardingStep: {},
    table: {}
  },
  setup(__props: any) {

    

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.onboardingStep }, {
    default: _withCtx(() => [
      _createVNode(EditOnboardingStep, {
        "onboarding-step": _ctx.onboardingStep,
        table: _ctx.table
      }, null, 8, ["onboarding-step", "table"]),
      _createVNode(Delete, {
        route: _ctx.route('v2.onboarding.destroy', { companyOnboardingStep: _ctx.onboardingStep.id }),
        "query-key": [_unref(QueryKey).ONBOARDING, selectedCompanyId.value],
        header: "onboarding.delete.title"
      }, null, 8, ["route", "query-key"])
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})